/*eslint no-console: 0*/
import config from '../../../lib/config'
import PageMixins from '../../../components/_mixins/pages'
import ValidationMixins from '../../../components/_mixins/validation'

import { required, email } from 'vuelidate/lib/validators'
import MainService from '../../../services/main'

export default {
  name: 'forget-password',
  settings: 'page.login.forgotPassword',
  translations: 'page.login.forgotPassword',
  mixins:[PageMixins, ValidationMixins],
  props: ['email'],
  components: {},
  data() {
    return {
      resendCount: 0,
      sendingResetRequest: false,
      resetRequestSent: false,
      requestSentError: '',
      reseturl:  window.location.origin + this.$router.match({ name: 'user.password.reset' }).path,
      forgotPasswordEmail: '',
      validations: {
        forgotPasswordEmail: {
          name: 'forgotPasswordEmail',
          validator: this.submittingInvalidRule,
          items: {
            required: {error: 'Email is required.'},
            email: {error: 'Email is not valid.'},
          },
        },
      }
    }
  },
  validations: {
    forgotPasswordEmail: {
      required,
      email
    },
  },
  mounted() {
    this.$v.$reset()
    this.requestSentError = ''
    this.resendCount = 0
    this.forgotPasswordEmail = this.email || ''
    this.resetRequestSent = false
  },
  methods: {
    async requestResetLink() {
      this.$v.$touch()
      this.formSubmitting = true
      this.requestSentError = ''
      if (!this.isAnyInvalid) {
        const email = this.forgotPasswordEmail
        const reseturl = this.reseturl
        this.resetRequestSent = false
        this.sendingResetRequest = true
        try {
          const data = await MainService.forgotPassword({email, reseturl})
          this.resetRequestSent = true
        } catch (e) {
          this.requestSentError = MainService.getFirstErrorMessage(e)
        }
        this.sendingResetRequest = false
      }
    },
    async resend() {
      try {
        const data = await this.requestResetLink()
        this.resendCount++
      } catch (e) {

      }
    },
    backToSignIn() {
      this.showResetPassword(false)
    }
  }
}
